module.exports = __webpack_public_path__ + "img/band.352c6750.png";